/** Content / branding image imports (from assets/images). */
import topicusLogo from '~/assets/images/topicus_logo.png';
import footerLogo from '~/assets/images/footer_logo.png';
import loginHeader from '~/assets/images/login_header.png';
import contactHeader from '~/assets/images/contact_header.png';
import placeholder from '~/assets/images/placeholder.png';
import smiley1 from '~/assets/images/smiley_1.png';
import smiley2 from '~/assets/images/smiley_2.png';
import smiley3 from '~/assets/images/smiley_3.png';
import smiley4 from '~/assets/images/smiley_4.png';
import smiley5 from '~/assets/images/smiley_5.png';

const Images = {
	topicusLogo,
	footerLogo,
	loginHeader,
	contactHeader,
	placeholder,
	smiley1,
	smiley2,
	smiley3,
	smiley4,
	smiley5,
};

export default Images;
